import {
  TextProps,
  WithChildren
} from '@viveaesthetics/elemy-shared-core/lib/components/types'
import { Text } from '@viveaesthetics/shared'
import styled, { css } from 'styled-components'

interface TitleProps extends TextProps, WithChildren {
  type: 'title1' | 'title2' | 'title3'
}

const TextStyled = styled(Text)<TitleProps>`
  ${({ type, theme }) => {
    switch (type) {
      case 'title1':
        return css`
          font-family: 'PP Hatton', ${theme.text.fontFamily.heading};
          font-weight: 500;
          font-size: 3.2rem;
          line-height: 4rem;
          letter-spacing: -0.03rem;
        `
      case 'title2':
        return css`
          font-family: 'PP Hatton', ${theme.text.fontFamily.heading};
          font-weight: 500;
          font-size: 2.8rem;
          line-height: 3.6rem;
          letter-spacing: -0.02rem;
        `
      case 'title3':
        return css`
          font-family: 'PP Hatton', ${theme.text.fontFamily.heading};
          font-weight: 500;
          font-size: 2rem;
          line-height: 3.2rem;
        `
      default:
        return ''
    }
  }}
`

export const Title = (props: TitleProps) => <TextStyled {...props} />
